module.exports = __webpack_public_path__ + "static/media/info.4f72e7f3.svg";